export const authInitialState = {
  user: null,
  isAuthenticated: false,
  accessToken: null,
  loading: false,
  error: null,
};

export const dashboardInitialState = {
  userData: {
    myShare: 0,
    matchCommission: 0,
    balance: 0,
    members: 0,
    sessionCommission: 0,
    balanceWithPnl: 0,
    companyShare: 0,
    userId: null,
  },
  matches: [],
  loading: {
    userData: false,
    matches: false,
  },
  errors: {
    userData: null,
    matches: null,
  },
  lastFetched: {
    userData: null,
    matches: null,
  },
};

export const matchDetailInitialState = {
  matchInfo: null,
  scoreUrl: null,
  tvUrl: null,
  channelId: null,
  oddsData: [],
  bookmakerData: [],
  fancyData: [],
  fancyList: [],
  matchBets: {
    team1: null,
    team2: null,
    team3: null,
    betList: [],
  },
  sessionBets: [],
  completedFancy: [],
  loading: {
    matchInfo: false,
    odds: false,
    bets: false,
    fancy: false,
    completedFancy: false,
  },
  errors: {
    matchInfo: null,
    odds: null,
    bets: null,
    fancy: null,
    completedFancy: null,
  },
};

export const userManagementInitialState = {
  users: [],
  totalPages: 0,
  currentPage: 0,
  selectedUser: null,
  parentShare: null,
  loading: {
    list: false,
    create: false,
    update: false,
    parentShare: false,
    action: false,
  },
  errors: {
    list: null,
    create: null,
    update: null,
    parentShare: null,
    action: null,
  },
  createResult: null,
};